import React from 'react';
import styled from 'styled-components';

const SectionHeaderContainer = styled.div`
  padding-top: 49px;
  padding-bottom: 50px;
  text-align: center;
  line-height: 38px;
`;

const SectionHeaderInner = styled.div`
  max-width: 990px;
  padding: 0 25px;
  margin: 0 auto;
`;

const Label = styled.p`
    font-size: 24px;
    margin: 0;
`

const Desc = styled.a`
    font-size: 18px;
    margin: 0;
    text-decoration: none;
    color: #4a4a4a;
`


function TcnhInfo({ input }) {
    const { items } = input;
    const baseUrl = 'https://tronscan.org/#/token20/'
    return (
        <SectionHeaderContainer>
            <SectionHeaderInner>
            {items.map((item, index) => {
                return (
                    <div key={index}>
                            {item && (
                                <div>
                                    <Label>{item.label.text}</Label>
                                    <Desc href={baseUrl + item.desc.text} target="_blank">{item.desc.text}</Desc>
                                </div>
                            )}
                    </div>
                );
            })}
            </SectionHeaderInner>
        </SectionHeaderContainer>
    );
}

export { TcnhInfo };
